import { Fragment } from "react";
import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { BonusUi, Carousel } from "../../../Constants/Constants";
import AutoPlayVariant from "./AutoPlayVariant";
import CrossFade from "./CrossFade";
import DarkVariant from "./DarkVariant";
import DisableTouchSwiping from "./DisableTouchSwiping";
import EffectCoverflow from "./EffectCoverflow";
import IndividualInterval from "./IndividualInterval";
import MouseWheelVariant from "./MouseWheelVariant";
import NestedSwiper from "./NestedSwiper";
import SlidesOnly from "./SlidesOnly";
import VerticalSlider from "./VerticalSlider";
import WithCaptions from "./WithCaptions";
import WithControls from "./WithControls";
import WithIndicators from "./WithIndicators";

const CarouselContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={Carousel} parent={BonusUi} />
      <Container fluid>
        <Row>
          <SlidesOnly />
          <WithControls />
          <WithIndicators />
          <WithCaptions />
          <CrossFade />
          <IndividualInterval />
          <DisableTouchSwiping />
          <DarkVariant />
        </Row>
        <Row>
          <VerticalSlider />
          <NestedSwiper />
          <MouseWheelVariant />
          <AutoPlayVariant />
          <EffectCoverflow />
        </Row>
      </Container>
    </Fragment>
  );
};

export default CarouselContainer;
